import DeleteIcon from "@mui/icons-material/Delete";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import { type CSSProperties, type FC, useEffect, useState } from "react";

type Props = {
	isLoading?: boolean;
	onDeleteConfirmed: () => void;
	opacityWhenNotHovered?: CSSProperties["opacity"];
};

export const DoubleClickDeleteIcon: FC<Props> = ({ isLoading, onDeleteConfirmed, opacityWhenNotHovered = 0.15 }) => {
	const [displayDoubleClickTooltip, setDisplayDoubleClickTooltip] = useState(false);
	const [singleClicked, setSingleClicked] = useState(false);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (singleClicked) {
				setDisplayDoubleClickTooltip(true);
			}
		}, 750);
		return () => clearTimeout(timeout);
	}, [singleClicked]);

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (displayDoubleClickTooltip) {
				setSingleClicked(false);
				setDisplayDoubleClickTooltip(false);
			}
		}, 2500);
		return () => clearTimeout(timeout);
	}, [displayDoubleClickTooltip]);

	return (
		<Tooltip title={"Double click to confirm deletion"} placement={"top"} open={displayDoubleClickTooltip}>
			<IconButton
				disabled={isLoading}
				size={"small"}
				onClick={(e) => {
					e.stopPropagation();
					setSingleClicked(true);
				}}
				onDoubleClick={(e) => {
					e.stopPropagation();
					setDisplayDoubleClickTooltip(false);
					setSingleClicked(false);
					onDeleteConfirmed();
				}}
			>
				{isLoading && !singleClicked ? (
					<CircularProgress size={16} />
				) : (
					<DeleteIcon
						fontSize={"inherit"}
						color={"inherit"}
						sx={{
							opacity: opacityWhenNotHovered,
							transition: "opacity 0.2s",
							fontSize: "16px",
							":hover": {
								opacity: 1,
							},
						}}
					/>
				)}
			</IconButton>
		</Tooltip>
	);
};
